import React, { useEffect, useState } from 'react'
import { Auth } from 'aws-amplify'
import { useSelector } from 'react-redux'
import Button from 'antd/lib/button'

const styles = {
    container: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    button: {
        backgroundColor: '#1BAAF1',
        borderColor: '#1BAAF1',
    },
}

const goBack = () => {
    window.location.replace('/')
}

const ConfirmRegistration = () => {
    const username = useSelector((state) => state.auth.username)
    const confirmationCode = useSelector((state) => state.auth.confirmationCode)
    const resend = useSelector((state) => state.auth.resendConfirmationCode)

    const [message, setMessage] = useState(
        'Please check your email for a confirmation link and further steps.'
    )

    useEffect(() => {
        if (username && confirmationCode) {
            Auth.confirmSignUp(username, confirmationCode)
                .then(() => {
                    setMessage(
                        'Congratulations! Your account has been verified. You will now be directed to the login screen.'
                    )
                    setTimeout(() => {
                        window.location.replace('/')
                    }, 5000)
                })
                .catch((err) => console.log('error confirming signing up: ', err))
        }
    }, [username, confirmationCode])

    useEffect(() => {
        if (resend) {
            setMessage('Your email has not been confirmed, do you want to resend code?')
        }
    }, [resend])

    const resendConfirmationCode = (username) => {
        Auth.resendSignUp(username)
            .then(() => {
                setMessage('New confirmation link has been sent, please check your email.')
            })
            .catch((err) =>
                setMessage('Error could not send a new confirmation code, please contact support.')
            )
    }

    return (
        <div style={styles.container}>
            {message}
            {resend && (
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2em' }}>
                    <Button onClick={goBack}>Back</Button>
                    <Button type="primary" onClick={() => resendConfirmationCode(username)}>
                        Resend
                    </Button>
                </div>
            )}
        </div>
    )
}

export default ConfirmRegistration
